// ============================================================
// Template HTML del módulo de OPCIONES
// ============================================================
import { mostrarToast, obtenerUrlBackend } from './utilerias.js';


const URL_BASE_API = obtenerUrlBackend('8083');

const API_BASE_URL = `${URL_BASE_API}/api`;

const TOKEN_KEY = 'token_teresita'; 

const templateOpciones = `
  <div class="opciones-container">
    <div class="opciones-header">
      <button id="btnAgregarOpcion" class="btn btn-primary btn-icon">
        <i class="fas fa-plus"></i>
        Nueva Opción
      </button>
    </div>

    <div class="card">
      <div class="table-responsive">
        <table id="tablaOpciones" class="table table-striped" style="width:100%">
          <thead>
            <tr>
              <th>ID</th>
              <th>Código</th>
              <th>Nombre</th>
              <th>Orden</th>
              <th>Ruta</th>
              <th>Activo</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Modal Opción -->
  <div id="modalOpcion" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h4 id="modalTitulo">Nueva Opción</h4>
        <button class="modal-close" id="btnCerrarModal">&times;</button>
      </div>
      <div class="modal-body">
        <form id="formOpcion">
          <!-- Campo oculto para id_opcion -->
          <input type="hidden" id="id_opcion" name="id_opcion">

          <div class="form-group">
            <label for="codigo">Código *</label>
            <input type="text" id="codigo" name="codigo" class="form-control" required maxlength="20">
          </div>

          <div class="form-group">
            <label for="nombre">Nombre *</label>
            <input type="text" id="nombre" name="nombre" class="form-control" required maxlength="100">
          </div>

          <div class="form-group">
            <label for="orden">Orden *</label>
            <input type="number" id="orden" name="orden" class="form-control" required min="0">
          </div>

          <div class="form-group">
            <label for="ruta">Ruta *</label>
            <input type="text" id="ruta" name="ruta" class="form-control" required maxlength="255" placeholder="Ej: /dashboard">
          </div>

          <div class="form-group">
            <label for="icono">Icono</label>
            <input type="text" id="icono" name="icono" class="form-control" maxlength="50" placeholder="Ej: fa-chart-line">
          </div>

          <div class="form-group">
            <label for="id_padre">Opción Padre (ID)</label>
            <input type="number" id="id_padre" name="id_padre" class="form-control" min="0" placeholder="Dejar vacío si es opción principal">
          </div>

          <div class="form-group">
            <label for="activo">Activo</label>
            <select id="activo" name="activo" class="form-control">
              <option value="true">Sí</option>
              <option value="false">No</option>
            </select>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="btnCancelar">Cancelar</button>
        <button type="submit" class="btn btn-primary" id="btnGuardar" form="formOpcion">
          <i class="fas fa-save"></i> Guardar
        </button>
      </div>
    </div>
  </div>

  <!-- Modal Confirmar Eliminación -->
  <div id="modalConfirmar" class="modal-overlay">
    <div class="modal-container modal-sm">
      <div class="modal-header modal-header-danger">
        <h3><i class="fas fa-exclamation-triangle"></i> Confirmar Eliminación</h3>
      </div>
      <div class="modal-body text-center">
        <p>¿Está seguro de que desea eliminar la opción <strong id="nombreOpcionEliminar"></strong>?</p>
        <p class="text-muted">ID: <span id="idOpcionEliminar"></span></p>
        <p class="text-muted">Esta acción no se puede deshacer.</p>
      </div>
      <div class="modal-footer justify-center">
        <button class="btn btn-secondary" id="btnCancelarEliminar">Cancelar</button>
        <button class="btn btn-danger" id="btnConfirmarEliminar">
          <i class="fas fa-trash-alt"></i> Sí, Eliminar
        </button>
      </div>
    </div>
  </div>
`;

let tablaInstancia = null;
let opcionActual = null;   
let opcionAEliminar = null; 

function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function paginaMntoOpciones() {
  setTimeout(() => inicializarModulo(), 0);
  return templateOpciones;
}

async function inicializarModulo() {
  await cargarOpciones();
  bindEvents();
}

async function cargarOpciones() {
  const token = getToken();

  try {
    const respuesta = await fetch(`${API_BASE_URL}/mntoOpciones`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    if (!respuesta.ok) throw new Error('Error al cargar opciones');

    const data = await respuesta.json();
    inicializarTabla(data);

  } catch (error) {
    console.error('Error:', error);
    mostrarToast('Error al cargar opciones', 'error');
  }
}

function inicializarTabla(opcionesData) {
  const $tabla = $('#tablaOpciones');

  
  if ($.fn.DataTable.isDataTable($tabla)) {
    $tabla.DataTable().destroy();
  }

  
  $tabla.find('thead th').each(function() {
    const textoOriginal = $(this).contents().filter(function() {
      return this.nodeType === 3;
    }).text();

    $(this).html(textoOriginal);
  });

 
  $tabla.find('tbody').empty();

  
  tablaInstancia = $tabla.DataTable({
    responsive: true,
    language: {
        //url: '"https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json',
"sProcessing":     "Procesando...",
        "sLengthMenu":     "Mostrar _MENU_ registros",
        "sZeroRecords":    "No se encontraron resultados",
        "sEmptyTable":     "Ningún dato disponible en esta tabla",
        "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
        "sSearch":         "Buscar:",
        "sInfoThousands":  ",",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
            "sFirst":    "Primero",
            "sLast":     "Último",
            "sNext":     "Siguiente",
            "sPrevious": "Anterior"
        },
        "oAria": {
            "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
            "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },

      emptyTable: "No hay opciones registradas",
      zeroRecords: "No se encontraron coincidencias"
    },
    data: opcionesData,
    columns: [
      { data: 'id_opcion', width: '8%', searchable: true, className: 'text-center' },
      { data: 'codigo', width: '12%', searchable: true },
      { data: 'nombre', width: '25%', searchable: true },
      { data: 'orden', width: '8%', searchable: true, className: 'text-center' },
      { data: 'ruta', width: '22%', searchable: true },
      { data: 'activo', width: '10%', searchable: false, className: 'text-center', render: renderActivo },
      { 
        data: null, 
        width: '15%', 
        orderable: false, 
        searchable: false,
        className: 'text-center',
        render: renderAcciones
      }
    ],
    initComplete: function () {
      this.api().columns().every(function (index) { 
        var column = this;
        var title = $(column.header()).text();

        if (column.settings()[0].aoColumns[index].bSearchable === false) {
          return;
        }

        var input = $('<input type="text" class="filtro-columna form-control form-control-sm" placeholder="Filtrar ' + title + '" />')
          .appendTo($(column.header()))
          .on('keyup change clear', function () {
            if (column.search() !== this.value) {
              column.search(this.value).draw();
            }
          })
          .on('click', function(e) {
            e.stopPropagation();
          });
      });

      var contenedor = document.getElementById('estado-contenedor');
      if (contenedor) {
        contenedor.style.display = 'none';
      }
    },
    order: [[0, 'asc']],  // Ordenar por id_opcion ascendente
    pageLength: 10,
    lengthMenu: [[5, 10, 25, 50], [5, 10, 25, 50]],
    dom: 'rtip'
  });
}

function renderActivo(data) {
  const esActivo = data === true || data === 'true' || data === 't' || data === 1 || data === '1';
  
  return esActivo
    ? '<span style="color: #155724;  padding: 4px 12px; border-radius: 4px; font-weight: bold;">Sí</span>' 
    : '<span style="color: #721c24;  padding: 4px 12px; border-radius: 4px; font-weight: bold;">No</span>';
}

function renderAcciones(data) {
  return `
    <div class="acciones-cell">
      <button class="btn-action btn-edit" data-id="${data.id_opcion}" title="Editar ID: ${data.id_opcion}">
        <i class="fas fa-pencil-alt"></i>
      </button>
    </div>
  `;
}

function bindEvents() {
  $('#btnAgregarOpcion').off('click').on('click', abrirModalAgregar);

  
  $(document).off('click', '#tablaOpciones tbody .btn-edit').on('click', '#tablaOpciones tbody .btn-edit', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const idOpcion = $(this).data('id');
    console.log('Click editar, id_opcion:', idOpcion);
    abrirModalEditar(idOpcion);
  });


  $(document).off('click', '#tablaOpciones tbody .btn-delete').on('click', '#tablaOpciones tbody .btn-delete', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const idOpcion = $(this).data('id');
    const nombre = $(this).data('nombre');
    console.log('Click eliminar, id_opcion:', idOpcion, 'nombre:', nombre);
    abrirModalEliminar(idOpcion, nombre);
  });

  $('#formOpcion').off('submit').on('submit', function(e) {
    e.preventDefault();
    guardarOpcion();
  });

  $('#btnCerrarModal, #btnCancelar').off('click').on('click', cerrarModal);
  $('#btnCancelarEliminar').off('click').on('click', cerrarModalEliminar);
 

  $('.modal-overlay').off('click').on('click', function(e) {
    if ($(e.target).hasClass('modal-overlay')) {
      cerrarModal();
      cerrarModalEliminar();
    }
  });
}

function abrirModalAgregar() {
  opcionActual = null;  
  $('#modalTitulo').text('Nueva Opción');
  $('#formOpcion')[0].reset();
  $('#id_opcion').val('');  
  $('#codigo').prop('disabled', false);
  $('#activo').val('true');
  $('#modalOpcion').addClass('active');
  $('#codigo').focus();
}

async function abrirModalEditar(idOpcion) {
  const token = getToken();

  console.log('Editando opción con id_opcion:', idOpcion);

  const url = `${API_BASE_URL}/mntoOpciones/${idOpcion}`;
  console.log('URL de consulta:', url);

  try {
    const response = await fetch(url, {
      headers: { 
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error(`Opción con ID ${idOpcion} no encontrada`);
      }
      throw new Error(`Error ${response.status} al obtener opción`);
    }

    const opcionData = await response.json();
    console.log('Datos recibidos del backend:', opcionData);

    
    opcionActual = opcionData.id_opcion;

    
    $('#id_opcion').val(opcionData.id_opcion);
    $('#modalTitulo').text('Editar Opción (ID: ' + opcionData.id_opcion + ')');
    $('#codigo').val(opcionData.codigo).prop('disabled', true);
    $('#nombre').val(opcionData.nombre);
    $('#orden').val(opcionData.orden);
    $('#ruta').val(opcionData.ruta);
    $('#icono').val(opcionData.icono || '');
    $('#id_padre').val(opcionData.id_padre || '');
    $('#activo').val(opcionData.activo === true || opcionData.activo === 'true' ? 'true' : 'false');

    $('#modalOpcion').addClass('active');
    $('#nombre').focus();

  } catch (error) {
    console.error('Error:', error);
    mostrarToast('Error al cargar opción: ' + error.message, 'error');
  }
}

function cerrarModal() {
  $('#modalOpcion').removeClass('active');
  $('#formOpcion')[0].reset();
  $('#id_opcion').val('');  // ← Limpiar PK oculto
  opcionActual = null;      // ← Limpiar variable global
}

async function guardarOpcion() {
  const token = getToken();

  
  const datos = {
    codigo: $('#codigo').val().trim(),
    nombre: $('#nombre').val().trim(),
    orden: parseInt($('#orden').val()),
    ruta: $('#ruta').val().trim(),
    activo: $('#activo').val() === 'true',
    icono: $('#icono').val().trim() || null,
    id_padre: $('#id_padre').val() ? parseInt($('#id_padre').val()) : null
  };

  
  if (!datos.codigo || !datos.nombre || isNaN(datos.orden) || !datos.ruta) {
    mostrarToast('Complete todos los campos obligatorios', 'error');
    return;
  }

  const esNuevo = !opcionActual;
  const method = esNuevo ? 'POST' : 'PUT';

  try {
    
    const url = esNuevo 
      ? `${API_BASE_URL}/mntoOpciones`           // POST: /api/mntoOpciones
      : `${API_BASE_URL}/mntoOpciones/${opcionActual}`;  // PUT: /api/mntoOpciones/2

    console.log('Guardando opción:', { esNuevo, method, url, id_opcion: opcionActual, datos });

    const response = await fetch(url, {
      method: method,
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(datos)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || error.message || 'Error al guardar');
    }

    const resultado = await response.json();
    console.log('Respuesta del servidor:', resultado);

    mostrarToast(
      esNuevo ? `Opción creada correctamente (ID: ${resultado.opcion?.id_opcion || 'N/A'})` 
              : `Opción actualizada correctamente (ID: ${opcionActual})`,
      'success'
    );

    cerrarModal();
    await cargarOpciones();

  } catch (error) {
    console.error('Error al guardar:', error);
    mostrarToast(error.message, 'error');
  }
}

function abrirModalEliminar(idOpcion, nombre) {
  opcionAEliminar = idOpcion;  
  $('#nombreOpcionEliminar').text(nombre);
  $('#idOpcionEliminar').text(idOpcion);  
  $('#modalConfirmar').addClass('active');
}

function cerrarModalEliminar() {
  $('#modalConfirmar').removeClass('active');
  opcionAEliminar = null;  // ← Limpiar PK
}

async function eliminarOpcion() {
  console.log('opcionAEliminar:', opcionAEliminar);
  debugger
  if (!opcionAEliminar) {
    mostrarToast('Error: No se seleccionó opción para eliminar', 'error');
    return;
  }

  const token = getToken();

  console.log('Eliminando opción con id_opcion:', opcionAEliminar);

  try {
    const url = `${API_BASE_URL}/mntoOpciones/${opcionAEliminar}`;
    console.log('URL de eliminación:', url);

    const response = await fetch(url, {
      method: 'DELETE',
      headers: { 
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));

      if (response.status === 404) {
        throw new Error(`Opción con ID ${opcionAEliminar} no encontrada`);
      } else if (response.status === 409) {
        throw new Error(errorData.error || 'La opción tiene registros relacionados');
      } else {
        throw new Error(errorData.error || `Error ${response.status} al eliminar`);
      }
    }

    const data = await response.json();

    mostrarToast(data.mensaje || `Opción ID ${opcionAEliminar} eliminada correctamente`, 'success');
    cerrarModalEliminar();
    await cargarOpciones();

  } catch (error) {
    console.error('Error al eliminar:', error);
    mostrarToast(error.message || 'Error al eliminar opción', 'error');
  } finally {
    opcionAEliminar = null;
  }
}

